import axios from "axios";

const createServiceRequest = async (plan) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/service-request`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllServiceRequest = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getServiceRequest = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getServiceRequestManyId = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/findManyById?ids=${param}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editServiceRequest = async (id, plan) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/service-request/${id}`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteServiceRequest = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/service-request/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getFindJob = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/find-job${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getFindJobItem = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/find-job-item${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getFindJobSeqno = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/find-job/seq-no${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getItemStepDes = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/ItemStepDescriptions/`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getContractSpec = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/ContractSpecDts/`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getStandardRec = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/ItemStdRecords/${id || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getReason = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Reasons`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const createWorkFlow = async (body) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/service-request/create-work-flow`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getSeqNoOperational = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/get-operational-infom/seqno${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getOperational = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/get-operational-infom${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getItemsOperational = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/service-request/get-operational-infom/items${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const ServiceRequestService = {
  createServiceRequest,
  getAllServiceRequest,
  getServiceRequest,
  getServiceRequestManyId,
  getFindJob,
  getFindJobItem,
  getFindJobSeqno,
  getItemStepDes,
  getContractSpec,
  getStandardRec,
  getReason,
  createWorkFlow,
  getOperational,
  getSeqNoOperational,
  getItemsOperational,
  editServiceRequest,
  deleteServiceRequest
};

export default ServiceRequestService;
